import React from 'react';
import {
  BuildingStorefrontIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  CogIcon,
} from '@heroicons/react/24/outline';

interface ComingSoonProps {
  title: string;
  description: string;
  icon?: 'stock' | 'reports' | 'billing' | 'settings';
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title, description, icon = 'settings' }) => {
  const getIcon = () => {
    switch (icon) {
      case 'stock':
        return BuildingStorefrontIcon;
      case 'reports':
        return ChartBarIcon;
      case 'billing':
        return CurrencyDollarIcon;
      default:
        return CogIcon;
    }
  };

  const IconComponent = getIcon();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-8">
          <div className="mb-6">
            <IconComponent className="w-16 h-16 text-gray-400 dark:text-gray-500 mx-auto mb-4" />
            <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">{title}</h1>
            <p className="text-gray-600 dark:text-gray-400 text-sm">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
